// extracted by mini-css-extract-plugin
export var container = "styles-module--container--0Ql8Z";
export var dockedBottom = "styles-module--dockedBottom--ZcOD9";
export var dockedTop = "styles-module--dockedTop--Ks3ND";
export var figure = "styles-module--figure--1XSYw";
export var grid = "styles-module--grid--fm8wZ";
export var image = "styles-module--image--MtANN";
export var padded = "styles-module--padded--w9iJ4";
export var video = "styles-module--video--qlBiy";